export const currentRegionSelector = (state: any) => state.region.region;

export const showRegionsSelector = (state: any) => state.region.showRegions;

export const supportedRegionsSelector = (state: any) => state.region.supportedRegions;

export const regionLoadedSelector = (state: any) => state.region.loaded;


